import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Calendar } from "lucide-react";
import { useTran } from "@/hooks";
import { SearchableSelect } from "@/components/common";
import { useCarbonTargetsStore } from "../../hooks";
import {
  formatYear,
  generateTargetYearOptions,
} from "../../utils/year-helpers";

const TargetYearCard = observer(() => {
  const { t } = useTran();
  const { selectedYear, setSelectedYear } = useCarbonTargetsStore();
  const options = useMemo(
    () =>
      generateTargetYearOptions().map((year) => ({
        value: String(year),
        label: formatYear(year),
      })),
    [],
  );

  return (
    <div className="rounded-radius border border-border bg-card p-4">
      <div className="mb-3">
        <label className="text-sm font-medium text-foreground">
          {t("Target Year")}
        </label>
        <p className="text-xs text-muted-foreground">
          {t("Select year to set targets for.")}
        </p>
      </div>
      <SearchableSelect
        value={String(selectedYear)}
        onChange={(val) => setSelectedYear(parseInt(val, 10))}
        options={options}
        placeholder={t("Select year")}
        searchPlaceholder={t("Search year")}
        emptyText={t("No year found")}
        className="justify-between"
      />
      <div className="mt-2 flex items-center gap-2 text-xs text-muted-foreground">
        <Calendar className="h-3.5 w-3.5" />
        <span>
          {t("Currently viewing")}:{" "}
          <span className="font-semibold text-foreground">{selectedYear}</span>
        </span>
      </div>
    </div>
  );
});

export default TargetYearCard;
